var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfluencers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.157,
    height: 17.157,
    viewBox: "0 0 17.157 17.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12732",
    "data-name": "Group 12732",
    transform: "translate(2591.718 -899.067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(-2586.009 904.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M-2520.031,1054.159h-.354c-1.084,0-2.639.732-2.639,1.955a.575.575,0,0,0,.509.633l.032,0h4.571a.566.566,0,0,0,.543-.587v-.049C-2517.37,1054.891-2518.925,1054.159-2520.031,1054.159Z",
    transform: "translate(2523.027 -1049.683)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M-2494.36,955.688a1.334,1.334,0,0,0,1.011-.424,3,3,0,0,0,.636-1.932,1.649,1.649,0,0,0-1.649-1.649,1.649,1.649,0,0,0-1.649,1.649,3.083,3.083,0,0,0,.636,1.955A1.4,1.4,0,0,0-2494.36,955.688Z",
    transform: "translate(2497.19 -951.683)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_648",
    "data-name": "Ellipse 648",
    cx: 7.032,
    cy: 7.032,
    r: 7.032,
    transform: "translate(-2590.21 900.613)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_650",
    "data-name": "Ellipse 650",
    cx: 1.579,
    cy: 1.579,
    r: 1.579,
    transform: "translate(-2577.718 906.067)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_653",
    "data-name": "Ellipse 653",
    cx: 1.579,
    cy: 1.579,
    r: 1.579,
    transform: "translate(-2584.718 902.224) rotate(-90)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_651",
    "data-name": "Ellipse 651",
    cx: 1.579,
    cy: 1.579,
    r: 1.579,
    transform: "translate(-2591.718 906.067)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_652",
    "data-name": "Ellipse 652",
    cx: 1.579,
    cy: 1.579,
    r: 1.579,
    transform: "translate(-2584.718 916.224) rotate(-90)",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencers);
export default __webpack_public_path__ + "static/media/influencers.78bb5bdb179887d7a2774a947e1e7e6f.svg";
export { ForwardRef as ReactComponent };